if (!customElements.get('testimonial-swiper-slide')) {
  customElements.define(
    'testimonial-swiper-slide',
    class TestimonialSwiper extends HTMLElement {
      constructor() {
        super();
        this.swiperInstance = null;
        this._handleResize = this.initBasedOnDevice.bind(this);
      }

      connectedCallback() {
        this.ensureSwiperMarkup();
        this.initBasedOnDevice();
        window.addEventListener('resize', this._handleResize);
      }

      disconnectedCallback() {
        window.removeEventListener('resize', this._handleResize);
        if (this.swiperInstance) {
          this.swiperInstance.destroy(true, true);
          this.swiperInstance = null;
        }
      }

      ensureSwiperMarkup() {
        if (!this.querySelector('.swiper')) {
          const swiper = document.createElement('div');
          swiper.classList.add('swiper');

          const wrapper = this.querySelector('.swiper-wrapper');
          swiper.appendChild(wrapper);
          this.prepend(swiper);
        }
      }

      initBasedOnDevice() {
        const pcSwipe = this.dataset.pcSwipe === 'true';
        const mobileSwipe = this.dataset.mobileSwipe === 'true';
        const isMobile = window.innerWidth < 768;

        const shouldInit = (isMobile && mobileSwipe) || (!isMobile && pcSwipe);

        if (shouldInit && !this.swiperInstance) {
          this.initializeSwiper();
        } else if (!shouldInit && this.swiperInstance) {
          this.swiperInstance.destroy(true, true);
          this.swiperInstance = null;
        }
      }

      initializeSwiper() {
        if (window.Swiper) {
          this.initSwiperInstance();
          return;
        }

        const script = document.createElement('script');
        script.src = 'https://cdn.jsdelivr.net/npm/swiper@11/swiper-bundle.min.js';
        script.onload = () => this.initSwiperInstance();
        document.head.appendChild(script);
      }

      /* ----------------------------
        PROGRESS BAR CALCULATION
      ----------------------------- */
      updateProgressBar(swiper) {
        const progressBar = document.querySelector(
          'scroll-progress-bar .progress-bar'
        );

        if (!progressBar) return;

        const slidesPerView = swiper.params.slidesPerView;
        const totalSlides = swiper.slides.length;

        const totalSteps = Math.max(
          totalSlides - Math.ceil(slidesPerView) + 1,
          1
        );

        const currentStep = Math.min(swiper.realIndex + 1, totalSteps);
        const percentage = (currentStep / totalSteps) * 100;

        progressBar.style.width = `${percentage}%`;
      }

      initSwiperInstance() {
        const slidesDesktop = parseFloat(this.dataset.slidesPerViewDesktop) || 3;
        const slidesTablet = parseFloat(this.dataset.slidesPerViewTablet) || 2;
        const slidesMobile = parseFloat(this.dataset.slidesPerViewMobile) || 1.1;

        const spaceDesktop = parseInt(this.dataset.spaceBetweenDesktop) || 20;
        const spaceTablet = parseInt(this.dataset.spaceBetweenTablet) || 20;
        const spaceMobile = parseInt(this.dataset.spaceBetweenMobile) || 16;

        const isMobile = window.innerWidth < 768;

        this.swiperInstance = new Swiper(this.querySelector('.swiper'), {
          loop: false,

          pagination: {
            el: this.querySelector('.swiper-pagination'),
            clickable: true,
          },

          scrollbar: {
            el: this.querySelector('.swiper-scrollbar'),
            draggable: true,
            hide: isMobile,
          },

          navigation: {
            nextEl: this.closest('.page-width')?.querySelector('.swiper-button-next'),
            prevEl: this.closest('.page-width')?.querySelector('.swiper-button-prev'),
          },

          breakpoints: {
            0: {
              slidesPerView: slidesMobile,
              spaceBetween: spaceMobile,
            },
            768: {
              slidesPerView: slidesTablet,
              spaceBetween: spaceTablet,
            },
            1024: {
              slidesPerView: slidesDesktop,
              spaceBetween: spaceDesktop,
            },
          },

          /* 🔥 PROGRESS EVENTS */
          on: {
            init: (swiper) => this.updateProgressBar(swiper),
            slideChange: (swiper) => this.updateProgressBar(swiper),
            resize: (swiper) => this.updateProgressBar(swiper),
            breakpoint: (swiper) => this.updateProgressBar(swiper),
          },
        });
      }
    }
  );
}
